<template>
  <div class="cultureCycle">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">养殖周期管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select
              v-model="fishBaseIds"
              filterable
              placeholder="请选择"
              size="small"
              @change="baseChange"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              placeholder="开始日期"
              :clearable="false"
              @change="changeTime(0)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              placeholder="结束日期"
              :clearable="false"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>状态&nbsp;&nbsp;</span>
            <el-select
              v-model="cleared"
              filterable
              placeholder="所在塘口"
              size="small"
            >
              <el-option
                v-for="(item, index) in clearList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              @click="getCultureCycle(1)"
              class="query"
              >查询</el-button
            >
            <el-button
              size="small"
              type="info"
              plain
              @click="add"
              class="add"
              v-if="edit"
              >增加</el-button
            >
            <ExportExcelBtn
              apiUrl="/api/FishBatch/Export"
              :queryParamsObj="queryParams"
              fileName="养殖周期管理.xls"
            />
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="cycleList.list"
          style="width: 100%"
          size="medium"
          @row-dblclick="dataBackFillGoods"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column
            prop="fishBaseName"
            label="基地"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="fishPondName"
            label="塘口"
            show-overflow-tooltip
            align="center"
            :filters="getPondFilterList"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="fishBatch" label="养殖周期" align="center">
          </el-table-column>
          <el-table-column
            label="主养品种"
            align="center"
            min-width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ mainFishText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="饵料系数" align="center" width="100">
            <template slot-scope="scope">
              {{ formatFoodCoefficient(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="开始日期"
            show-overflow-tooltip
            :formatter="formatter"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="clearedDate"
            label="清塘日期"
            show-overflow-tooltip
            :formatter="formatters"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="creater"
            align="center"
            label="制单人"
            :filters="getPeopleFilterList"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column label="清塘状态" align="center">
            <template slot-scope="scope" :current-change="change">
              <span size="mini" type="primary">
                {{ scope.row.clearedDate ? "已清塘" : "" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            :render-header="adjustRenderHeader"
          >
            <template slot-scope="scope" :current-change="change">
              <div v-if="!scope.row.clearedDate">
                <span
                  @click="handleClear(scope.$index, scope.row)"
                  class="content-clear"
                  v-if="edit"
                  >清塘</span
                >
                <span
                  @click="handleEdit(scope.$index, scope.row)"
                  class="content-edit"
                  >{{ edit ? "编辑" : "查看" }}</span
                >
                <span
                  @click="handleDelete(scope.$index, scope.row)"
                  class="content-del"
                  v-if="edit"
                  >删除</span
                >
              </div>
              <div v-if="scope.row.clearedDate">
                <span
                  @click="hasCleared(scope.$index, scope.row)"
                  class="content-edit"
                  >{{ edit ? "编辑" : "查看" }}</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
      <!-- 弹窗 -->
      <div v-if="dialogFormVisible">
        <el-dialog
          :title="titleName"
          :visible.sync="dialogFormVisible"
          width="766px"
        >
          <el-form
            :model="cycleForm"
            :rules="rulea"
            ref="cycleForm"
            class="cycleForm"
          >
            <el-form-item
              label="基地"
              prop="fishBaseName"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="cycleForm.fishBaseName"
                filterable
                :disabled="disabled || isClearedBatchLimitedEdit"
                placeholder="请选择"
                @change="getChangeFishPondNoBatch"
              >
                <el-option
                  v-for="(item, index) in addBaseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-form-item
                label="塘口"
                prop="fishPondName"
                required
                :label-width="formLabelWidth"
              >
                <el-col :span="14">
                  <el-form-item>
                    <el-select
                      placeholder="请选择"
                      filterable
                      @change="getLastBatch"
                      :disabled="disabled || isClearedBatchLimitedEdit"
                      v-model="cycleForm.fishPondName"
                      class="pondName"
                    >
                      <el-option
                        v-for="(item, index) in fishPondNoBatch"
                        :key="index"
                        :label="item.fishPondName"
                        :value="item.fishPondId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="batch">
                    <el-input
                      :disabled="
                        showLastBatch || isClearedBatchLimitedEdit
                      "
                      type="text"
                      class="batch"
                      :maxlength="num"
                      v-model.number="cycleForm.batch"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <span>批</span>
                </el-col>
              </el-form-item>
            </el-row>
            <el-form-item
              label="主养品种"
              :label-width="formLabelWidth"
              class="mainVarietyFormItem"
            >
              <el-row
                :gutter="10"
                type="flex"
                class="mainVarietyRow"
              >
                <el-col :span="12">
                  <el-select
                    v-model="mainCategoryItem"
                    clearable
                    filterable
                    :disabled="!edit"
                    class="mainVarietySelect"
                    placeholder="鱼分类"
                    @change="onMainCategoryChange"
                  >
                    <el-option
                      v-for="item in fishGetCategory"
                      :key="item.key"
                      :label="item.value"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="mainFishItem"
                    clearable
                    filterable
                    :disabled="!edit || !mainCategoryItem"
                    class="mainVarietySelect"
                    :placeholder="mainCategoryItem ? '鱼种' : '请先选择鱼分类'"
                  >
                    <el-option
                      v-for="item in fishGetCategoryName"
                      :key="item.key"
                      :label="item.value"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item
              label="饵料系数"
              prop="foodCoefficient"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="cycleForm.foodCoefficient"
                :disabled="!edit"
                clearable
                placeholder="可空，与养殖品种设置中格式一致"
              />
            </el-form-item>
            <el-form-item
              label="开始时间"
              prop="startDate"
              :label-width="formLabelWidth"
            >
              <!-- :disabled="disabled" -->
              <el-date-picker
                type="date"
                :clearable="false"
                placeholder="选择日期"
                :picker-options="startPickerTimeOptions"
                v-model="cycleForm.startDate"
                value-format="yyyy-MM-dd"
                :disabled="!edit || isClearedBatchLimitedEdit"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="清塘时间"
              prop="clearedDate"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                type="date"
                :clearable="true"
                :disabled="isClearTime || (edit && clearedPondTimeLocked)"
                :picker-options="clearPickerTimeOptions"
                v-model="cycleForm.clearedDate"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="备注"
              prop="mark"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="cycleForm.mark"
                :disabled="!edit"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                :maxlength="num50"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="edit">
            <el-button @click="cancel('cycleForm')">取 消</el-button>
            <el-button
              type="primary"
              @click="save('cycleForm')"
              :loading="loadingType"
              v-if="this.titleName === '添加养殖周期信息'"
              >保 存</el-button
            >
            <el-button
              type="primary"
              @click="saveEdit('cycleForm')"
              v-if="this.titleName === '编辑养殖周期信息'"
              >保 存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import ExportExcelBtn from "../../common/ExportExcelBtn";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
export default {
  name: "cultureCycle",
  mixins: [mixins],
  components: {
    PageChange,
    ExportExcelBtn,
  },
  data() {
    return {
      rowId: "",
      fishBaseIds: "", //基地
      baseList: [], //基地列表
      cleared: "", //塘口
      loadingType: false,
      clearList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "true",
          label: "已清塘",
        },
        {
          value: "false",
          label: "未清塘",
        },
      ],
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.getCultureCycle, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      //增加页
      formLabelWidth: "82px",
      titleName: "",
      dialogFormVisible: false,
      showLastBatch: false, // 弹框周期是否添+
      num: 4,
      num50: 50,
      startPickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      clearPickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      addBaseList: [], //基地列表
      /** 已清塘记录编辑时仅允许主养品种、饵料系数、备注，其余只读 */
      isClearedBatchLimitedEdit: false,
      /** 该塘口已开新周期（本行非最后一批）：清塘时间只读；未开新则清塘可编辑 */
      clearedPondTimeLocked: false,
      mainCategoryItem: null, // 主养品种-鱼分类（与塘口设置相同交互）
      mainFishItem: null, // 主养品种-鱼种
      cycleForm: {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: "",
        foodCoefficient: "",
      },
      rulea: {
        fishBaseName: [
          { required: true, message: "请选择基地", trigger: "change" },
        ],
        fishPondName: [
          { required: true, message: "请选择塘口", trigger: "change" },
        ],
        batch: [
          {
            required: true,
            min: 1,
            max: 9999,
            pattern: /^[1-9]*$/,
            message: "批次格式有误",
            trigger: "blur",
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        foodCoefficient: [
          { validator: this.validateFoodCoefficient, trigger: "blur" },
        ],
        mark: [{ required: false, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions(modules.cultureCycle, [
      "getCultureCycleInfo",
      "getCycleList", //分页查询周期
      "clearPond",
      "delcultureList",
      "addFishBatch", // 添加周期
      "getFishPondNoBatch", // 基地下已清塘的鱼塘
      "getEditFishBatchData", //获取数据
      "editFishBatchData", //更新
      "getHasClearedData", //已清塘数据
      "getLastBatchNo", // 塘口最后批次，用于是否已开新周期
    ]),
    ...mapActions(modules.base, [
      "getAllBaseList", //基地信息
      "getBaseList", //基地信息
    ]),
    ...mapActions(modules.pond, [
      "getFishPondNoBatch", // 基地下已清塘的鱼塘
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory",
      "getFishGetCategoryName",
    ]),
    // 格式化开始时间
    formatter(row) {
      if (!row.startDate) {
        return false;
      }
      return this.$timeformatDay(row.startDate);
    },
    // 格式化清塘时间
    formatters(row) {
      if (!row.clearedDate) {
        return "未清塘";
      }
      return this.$timeformatDay(row.clearedDate);
    },
    mainFishText(row) {
      if (!row) {
        return "--";
      }
      const a = row.mainFishCategoryName;
      const b = row.mainFishName;
      if (!a && !b) {
        return "--";
      }
      return [a, b].filter(Boolean).join(" / ");
    },
    formatFoodCoefficient(row) {
      if (!row || row.foodCoefficient == null || row.foodCoefficient === "") {
        return "--";
      }
      return row.foodCoefficient;
    },
    validateFoodCoefficient(rule, value, callback) {
      if (value !== 0 && !value) {
        callback();
      } else if (isNaN(value)) {
        callback(new Error("该值只能是数值类型"));
      } else if (value <= 0) {
        callback(new Error("请输入大于0的数值"));
      } else if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error("小数点后最多两位小数"));
      } else {
        callback();
      }
    },
    resetMainVarietyFields() {
      this.mainCategoryItem = null;
      this.mainFishItem = null;
      this.cycleForm.foodCoefficient = "";
    },
    onMainCategoryChange(val) {
      this.mainFishItem = null;
      if (!val) {
        return;
      }
      this.getFishGetCategoryName(val.key).catch((err) => {
        console.dir(err);
      });
    },
    fillMainVarietyFromResponse(data) {
      if (!data) {
        return;
      }
      this.getFishGetCategory().catch((err) => {
        console.dir(err);
      });
      this.mainCategoryItem = null;
      this.mainFishItem = null;
      this.cycleForm.foodCoefficient =
        data.foodCoefficient != null && data.foodCoefficient !== ""
          ? data.foodCoefficient
          : "";
      if (data.mainFishCategoryId == null) {
        return;
      }
      this.mainCategoryItem = {
        key: data.mainFishCategoryId,
        value: data.mainFishCategoryName || "",
      };
      this.getFishGetCategoryName(data.mainFishCategoryId)
        .then((rsp) => {
          if (rsp && rsp.status === 200) {
            if (data.mainFishId != null && data.mainFishId !== undefined) {
              this.mainFishItem = {
                key: data.mainFishId,
                value: data.mainFishName || "",
              };
            } else {
              this.mainFishItem = null;
            }
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    toMainFishPayload() {
      const c = this.mainCategoryItem;
      const f = this.mainFishItem;
      return {
        mainFishCategoryId: c ? c.key : null,
        mainFishCategoryName: c ? c.value : null,
        mainFishId: f ? f.key : null,
        mainFishName: f ? f.value : null,
        foodCoefficient: this.normalizeFoodCoef(this.cycleForm.foodCoefficient),
      };
    },
    /** 已选鱼分类时必须选择鱼种，否则 false */
    validateMainVarietyForSave() {
      if (this.mainCategoryItem && !this.mainFishItem) {
        this.$message.warning("已选择鱼分类，请选择鱼种");
        return false;
      }
      return true;
    },
    normalizeFoodCoef(v) {
      if (v === "" || v == null) {
        return null;
      }
      const n = Number(v);
      return isNaN(n) ? null : n;
    },
    adjustRenderHeader(createElement, { column }) {
      return createElement("span", [
        createElement("span", column.label),
        createElement(
          "el-tooltip",
          {
            class: "cell-s-tip",
            props: {
              content:
                "注意：清塘操作后，1.需要反清塘，点编辑将清塘日期清空后点保存可实现反清塘。2.如果开启新周期，则不可反清塘。若要强制编辑，则需要删除新周期。",
              effect: "dark",
              placement: "top",
            },
          },
          [
            createElement("i", {
              class: {
                "el-icon-warning": true,
              },
              style: {
                cursor: "pointer",
                color: "rgba(255,108,0,1)",
                paddingLeft: "5px",
              },
            }),
          ]
        ),
      ]);
    },
    //记住基地
    baseChange(e) {
      storage.set("base", e);
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    //塘口下拉--改变
    getLastBatch(val) {
      this.resetMainVarietyFields();
      let item = this.fishPondNoBatch.find((f) => f.fishPondId == val);
      if (item) {
        if (item.lastClearedDate === null) {
          // 判断是否为清塘 如果最后时间为null则可自动填写批次
          this.showLastBatch = false;
          this.cycleForm.batch = "";
        } else {
          // this.ruleForm.fishPondName.filter(f => f.this.ruleForm.batch);
          this.cycleForm.batch = item.lastBatch + 1;
          this.showLastBatch = true;
        }
      }
    },
    // 获取基地改变时塘口的数据
    getChangeFishPondNoBatch(e) {
      this.resetMainVarietyFields();
      this.cycleForm.fishPondName = "";
      this.cycleForm.batch = "";
      this.showLastBatch = false;
      this.getFishPondNoBatch(e)
        .then((rsp) => {
          if (rsp.status === 200) {
            if (this.fishPondNoBatch[0]) {
              this.cycleForm.fishPondName = this.fishPondNoBatch[0].fishPondId;
              if (this.fishPondNoBatch[0].lastClearedDate === null) {
                // 判断是否为清塘 如果最后时间为null则可自动填写批次
                this.showLastBatch = false;
                this.cycleForm.batch = "";
              } else {
                // this.ruleForm.fishPondName.filter(f => f.this.ruleForm.batch);
                this.cycleForm.batch = this.fishPondNoBatch[0].lastBatch + 1;
                this.showLastBatch = true;
              }
            }
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    // 查询周期数据
    getCultureCycle(pageNum) {
      this.pageInfo.pageNumber = pageNum || 1;
      this.getCycleList(this.queryParams)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //筛选
    filterHandler(value, row, column) {
      // 筛选过滤
      const property = column["property"];
      return row[property] === value;
    },
    //添加
    add() {
      this.clearedPondTimeLocked = false;
      this.dialogFormVisible = true;
      this.titleName = "添加养殖周期信息";
      this.disabled = false;
      this.isClearTime = true;
      this.isClearedBatchLimitedEdit = false;
      this.resetMainVarietyFields();
      this.cycleForm = {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: "",
        foodCoefficient: "",
      };
      this.getFishGetCategory().catch((err) => {
        console.dir(err);
      });
      let obj = {
        fishBaseName: this.fishBaseName,
      };
      this.getBaseList(obj).then((data) => {
        this.addBaseList = data;
        if (!this.addBaseList || !this.addBaseList.length) {
          return;
        }
        // 默认基地与列表页筛选一致；若与可选列表中能对上则用筛选值，避免先拉「第一项」的塘口再改基地导致与塘口数据不同步、下拉无选项
        let baseId = this.addBaseList[0].key;
        if (
          this.fishBaseIds &&
          this.addBaseList.some((b) => b.key === this.fishBaseIds)
        ) {
          baseId = this.fishBaseIds;
        }
        this.cycleForm.fishBaseName = baseId;
        this.getChangeFishPondNoBatch(baseId);
      });
    },
    //保存
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.validateMainVarietyForSave()) {
            return;
          }
          let obj = {
            fishPondId: this.cycleForm.fishPondName,
            batch: this.cycleForm.batch,
            startDate: this.cycleForm.startDate,
            remark: this.cycleForm.mark,
            ...this.toMainFishPayload(),
          };
          this.loadingType = true;
          this.addFishBatch(obj)
            .then((rsp) => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.loadingType = false;
                this.resetMainVarietyFields();
                this.cycleForm = {
                  fishBaseName: "",
                  fishPondName: "",
                  batch: "",
                  startDate: "",
                  clearedDate: "",
                  mark: "",
                  foodCoefficient: "",
                };
                this.getCultureCycle();
                this.dialogFormVisible = false;
                this.clearedPondTimeLocked = false;
                this.isClearedBatchLimitedEdit = false;
                this.$refs[formName].resetFields();
              }
            })
            .catch((err) => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancel(formName) {
      this.dialogFormVisible = false;
      this.clearedPondTimeLocked = false;
      this.isClearedBatchLimitedEdit = false;
      this.$refs[formName].resetFields();
      this.resetMainVarietyFields();
      this.cycleForm = {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: "",
        foodCoefficient: "",
      };
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      if (row.clearedDate == null) {
        this.clearedPondTimeLocked = false;
        this.isClearedBatchLimitedEdit = false;
        this.dialogFormVisible = true;
        if (this.edit) {
          this.titleName = "编辑养殖周期信息";
          this.isClearTime = false;
          this.showLastBatch = true;
        } else {
          this.titleName = "查看养殖周期信息";
          this.showLastBatch = true;
          this.isClearTime = true;
        }
        this.disabled = true;
        this.getEditFishBatchData(row.id)
          .then((rsp) => {
            if (rsp.status === 200) {
              this.cycleForm = rsp.data || [];
              this.cycleForm.clearedDate = "";
              this.fillMainVarietyFromResponse(this.cycleForm);
              this.rowId = row.id;
              return this.updateClearedPondTimeLockForListRow(row);
            }
          })
          .catch((err) => {
            console.dir(err);
          });
      }
    },
    // 与塘口最后批比较：有更新批次则锁定清塘时间
    updateClearedPondTimeLockForListRow(row) {
      this.clearedPondTimeLocked = false;
      if (!row || row.fishPondId == null) {
        return Promise.resolve();
      }
      return this.getLastBatchNo(row.fishPondId)
        .then((rsp) => {
          if (rsp && rsp.status === 200) {
            this.clearedPondTimeLocked =
              !!this.edit && Number(row.fishBatch) !== Number(rsp.data);
          } else {
            this.clearedPondTimeLocked = !!this.edit;
          }
        })
        .catch(() => {
          this.clearedPondTimeLocked = !!this.edit;
        });
    },
    //清塘
    handleClear(index, row) {
      this.$confirm("清塘后则该周期生产数据将停止计算，请谨慎操作！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.clearPond(row.id)
            .then((rsp) => {
              if (rsp.status === 200) {
                this.$message({
                  type: "success",
                  message: "清塘成功!",
                });
                this.getCultureCycle();
              }
            })
            .catch((err) => {
              console.dir(err);
            });
        })
        .catch(() => {});
    },
    //获取已清塘数据
    hasCleared(index, row) {
      this.clearedPondTimeLocked = false;
      this.updateClearedPondTimeLockForListRow(row)
        .then(() => {
          this.isClearedBatchLimitedEdit = true;
          this.dialogFormVisible = true;
          if (this.edit) {
            this.titleName = "编辑养殖周期信息";
            this.isClearTime = false;
            this.showLastBatch = true;
          } else {
            this.titleName = "查看养殖周期信息";
            this.showLastBatch = true;
            this.isClearTime = true;
          }
          this.disabled = true;
          return this.getHasClearedData(row.id);
        })
        .then((rsp) => {
          if (rsp.status === 200) {
            this.cycleForm = rsp.data || [];
            this.fillMainVarietyFromResponse(this.cycleForm);
            this.rowId = row.id;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //获取当前行数据
    handleEdit(index, row) {
      if (row.clearedDate == null) {
        this.clearedPondTimeLocked = false;
        this.isClearedBatchLimitedEdit = false;
        this.dialogFormVisible = true;
        if (this.edit) {
          this.titleName = "编辑养殖周期信息";
          this.isClearTime = false;
          this.showLastBatch = true;
        } else {
          this.titleName = "查看养殖周期信息";
          this.showLastBatch = true;
          this.isClearTime = true;
        }
        this.disabled = true;
        this.getEditFishBatchData(row.id)
          .then((rsp) => {
            if (rsp.status === 200) {
              this.cycleForm = rsp.data || [];
              this.cycleForm.clearedDate = "";
              this.fillMainVarietyFromResponse(this.cycleForm);
              this.rowId = row.id;
              return this.updateClearedPondTimeLockForListRow(row);
            }
          })
          .catch((err) => {
            console.dir(err);
          });
      }
    },
    //更新
    saveEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.validateMainVarietyForSave()) {
            return;
          }
          let obj = {
            id: this.rowId, //行id
            fishPondName: this.cycleForm.fishPondName,
            batch: this.cycleForm.batch,
            startDate: this.cycleForm.startDate,
            clearedDate: this.cycleForm.clearedDate,
            remark: this.cycleForm.mark,
            ...this.toMainFishPayload(),
          };
          this.editFishBatchData(obj)
            .then((rsp) => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getCultureCycle();
                this.dialogFormVisible = false;
                this.clearedPondTimeLocked = false;
                this.isClearedBatchLimitedEdit = false;
                this.$refs[formName].resetFields();
              }
            })
            .catch((err) => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.rowId = row.id;
          await this.delcultureList(this.rowId);
          this.getCultureCycle(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
        });
    },
  },
  computed: {
    ...mapState(modules.cultureCycle, ["cycleList"]),
    ...mapState(modules.pond, ["fishPondNoBatch"]),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
    getPondFilterList() {
      const res = new Map();
      let fiterList = this.cycleList.list
        .map((m) => ({
          value: m.fishPondName,
          text: m.fishPondName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getPeopleFilterList() {
      const res = new Map();
      let fiterList = this.cycleList.list
        .map((m) => ({
          value: m.creater,
          text: m.creater,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams() {
      let obj = {
        fishBaseId: fishBaseIdForQuery(this.fishBaseIds, this.baseList),
        startDate: this.start,
        endDate: this.end,
        cleared: this.cleared,
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
      };
      if (this.cleared !== "") {
        obj[this.cleared] = this.cleared;
      }
      return obj;
    },
  },

  async mounted() {
    //列表基地信息
    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.fishBaseIds = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    //存储时间
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
    //结束时间默认取今天
    this.end = this.$timeformatDay(new Date());
    this.getCultureCycle(1);
  },
};
</script>
<style lang="stylus">
.el-tooltip__popper {
  max-width: 590px !important;
  min-width: 590px !important;
  font-size: 16px !important;
  line-height: 28px;
}

.cultureCycle {
  .cycleForm {
    .el-row {
      .el-col-5 {
        .el-form-item__error {
          left: 9px;
        }
      }
    }
  }

  .el-dialog {
    min-height: 600px;
    height: auto;
    border-radius: 6px;

    .batch .el-input {
      width: 100px !important;
    }

    .batch .el-input__inner {
      width: 100px !important;
    }

    .el-dialog__header {
      border-radius: 6px 6px 0px 0px;
      padding: 16px 20px 16px;
      background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));

      .el-dialog__title {
        color: #fff;
      }
    }

    .el-input {
      width: 500px;
    }

    .el-input__inner {
      width: 500px;
      margin-left: 10px;
    }

    .pondName .el-input {
      width: 345px !important;

      .el-input__inner {
        width: 345px !important;
      }
    }

    /* 主养品种：与基地/备注等单行控件同宽(500px)，两列等分 + 间距，与其它 label 左对齐 */
    .mainVarietyFormItem {
      .el-form-item__content {
        line-height: normal;
      }
    }

    .mainVarietyRow {
      max-width: 500px;
      width: 100%;
      flex-wrap: nowrap;
    }

    .mainVarietySelect {
      width: 100%;
    }

    .mainVarietySelect .el-input {
      width: 100% !important;
    }

    .mainVarietySelect .el-input__inner {
      width: 100% !important;
      margin-left: 0 !important;
    }

    .el-form-item__content {
      z-index: 999999;
      line-height: 40px;
      position: relative;
      font-size: 14px;
    }

    .el-form .el-form-item .el-form-item__label {
      margin-left: 65px;
      text-align: right;
      color: #333;
      font-size: 16px;
    }

    .cycleForm {
      margin-left: 0px;
    }

    .el-dialog__close {
      color: #fff;
    }

    .el-dialog__footer {
      position: relative;
      bottom: 12px;
      padding: 0px 0px 0px 0px;
      margin-right: 370px;
    }

    .el-button--primary {
      margin-left: 20px;
      background: #3389ff;
    }

    .el-button {
      width: 100px;
      height: 40px;
    }

    .el-button--default {
      margin-left: 117px;
    }

    .el-form-item .el-form-item__label:before {
      position: absolute;
      top: 2px;
      left: -12px;
      color: #fe3223;
    }

    .el-form-item__error {
      padding-top: 2px;
      position: absolute;
      top: 100%;
      left: 74px;
    }

    .el-icon-date {
      position: relative;
    }

    .el-icon-date:before {
      content: '\E608';
      position: absolute;
      left: 13px;
      top: 3px;
    }
  }

  .el-select.address .el-input {
    width: 160px !important;
  }

  .el-select.address .el-input__inner {
    width: 160px !important;
  }

  .el-col-7 {
    width: 26.34%;
  }
}
</style>
